import React, { useState, useEffect } from 'react';
import { Form, Input, FormGroup, Label, Button } from 'reactstrap';
import findIndex from 'lodash/findIndex';
import Axios from 'axios';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import TextFieldGroup from '../../Common/TextFieldGroup';
import ProgressIndicator from '../../Common/ProgressIndicator';
import { MEMBER, ADMIN, NOT_A_MEMBER, POGANY, BALEK, FIRMA } from '../../../Data/Constants';
import { memberStateToString, roleNameToHungarian } from '../../../Utils/Converters';
import SelectFieldGroup from '../../Common/SelectFieldGroup';
import { User } from '../../../Data/Classes';

function UserEditForm(props) {
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState({});
    const [user, setUser] = useState(null);

    useEffect(() => {
        setUser(props.user);
    }, [props.user]);

    function onChange(e) {
        setUser({ ...user, [e.target.name]: e.target.value });
    }

    function onCheckedChange(e) {
        setUser({ ...user, [e.target.name]: e.target.checked });
    }

    function onChangeCheckBoxGroup(e) {
        const index = findIndex(user[e.target.name], x => x === e.target.value);

        if (index !== -1)
            setUser({
                ...user,
                [e.target.name]: [
                    ...user[e.target.name].slice(0, index),
                    ...user[e.target.name].slice(index + 1)
                ]
            });
        else
            setUser({
                ...user,
                [e.target.name]: [
                    ...user[e.target.name],
                    e.target.value
                ]
            });
    }

    function onSubmit(e) {
        e.preventDefault();
        setIsSaving(true);

        const godparent1Id = user.godparent1Id === "" ? null : user.godparent1Id;
        const godparent2Id = user.godparent2Id === "" ? null : user.godparent2Id;

        Axios.post(`/admin/users/${user.id}`,
            new User(user.id,
                Number(user.memberState),
                user.isFreshman,
                user.memberState >= BALEK ? user.alias : null,
                user.memberState >= BALEK ? godparent1Id : null,
                user.memberState >= BALEK ? godparent2Id : null,
                user.roles))
            .then(res => {
                setIsSaving(false);
                toast.success("Felhasználó mentve.");
                window.history.back();
            }, err => {
                setIsSaving(false);
                setError(err.errors);
                toast.error("A felhasználó mentése sikertelen volt.");
            });
    }

    const firmaOptions = props.members.map((item) => 
        <option value={item.id} key={item.id}>{item.alias ? item.name + " alias " + item.alias : item.name}</option>
    );

    if (isSaving)
        return <ProgressIndicator />;

    if (user)
        return (
            <Form onSubmit={onSubmit}>
                <FormGroup tag="fieldset">
                    <legend>Alapadatok</legend>
                    <FormGroup row>
                        <FormGroup className="col-lg-3">
                            <Label for="name">Név</Label>
                            <Input type="text" name="name" value={user.name} readOnly />
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label for="email">Email cím</Label>
                            <Input type="text" name="email" value={user.email} readOnly />
                        </FormGroup>
                    </FormGroup>
                </FormGroup>
                <FormGroup tag="fieldset">
                    <legend>Körhöz kapcsolódó adatok</legend>
                    <FormGroup row>
                        <SelectFieldGroup className="col-lg-3"
                            field="memberState"
                            onChange={onChange}
                            label="Körtagság"
                            error={error.memberState}
                            value={user.memberState || NOT_A_MEMBER}
                        >
                            <option value={NOT_A_MEMBER}>{memberStateToString(NOT_A_MEMBER)}</option>
                            <option value={POGANY}>{memberStateToString(POGANY)}</option>
                            <option value={BALEK}>{memberStateToString(BALEK)}</option>
                            <option value={FIRMA}>{memberStateToString(FIRMA)}</option>
                        </SelectFieldGroup>
                        {user.memberState >= BALEK && <>
                            <TextFieldGroup className="col-lg-3"
                                field="alias"
                                onChange={onChange}
                                label="Alias"
                                error={error.alias}
                                value={user.alias}
                            />

                            <SelectFieldGroup className="col-lg-3"
                                field="godparent1Id"
                                onChange={onChange}
                                label="Keresztszülő"
                                error={error.godparent1Id}
                                value={user.godparent1Id}
                            >
                                <option value="">-</option>
                                {firmaOptions}
                            </SelectFieldGroup>

                            <SelectFieldGroup className="col-lg-3"
                                field="godparent2Id"
                                onChange={onChange}
                                label="Keresztszülő"
                                error={error.godparent2Id}
                                value={user.godparent2Id}
                            >
                                <option value="">-</option>
                                {firmaOptions}
                            </SelectFieldGroup>
                        </>}
                    </FormGroup>
                </FormGroup>
                <FormGroup tag="fieldset">
                    <legend>Adminisztratív adatok</legend>
                    <FormGroup row>
                        <FormGroup className="col-lg-3">
                            <Label for="firstLoginDate">Első bejelentkezés ideje</Label>
                            <Input type="text" name="firstLoginDate" value={new Date(user.firstLoginDate).toLocaleString("hu")} readOnly />
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label for="lastLoginDate">Utolsó bejelentkezés ideje</Label>
                            <Input type="text" name="lastLoginDate" value={new Date(user.lastLoginDate).toLocaleString("hu")} readOnly />
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label for="roles">Jogosultságok</Label>
                            <FormGroup check>
                                <Label check>
                                    <Input type="checkbox" name="isFreshman" value={user.isFreshman} checked={user.isFreshman} onChange={onCheckedChange} /> Gólya
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="checkbox" name="roles" value={MEMBER} checked={user.roles.includes(MEMBER)} onChange={onChangeCheckBoxGroup} />{' '} {roleNameToHungarian(MEMBER)}
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="checkbox" name="roles" value={ADMIN} checked={user.roles.includes(ADMIN)} onChange={onChangeCheckBoxGroup} />{' '} {roleNameToHungarian(ADMIN)}
                                </Label>
                            </FormGroup>
                        </FormGroup>
                    </FormGroup>
                </FormGroup>
                <Button color="primary" type="submit"><FontAwesomeIcon icon={faCheck} /> Mentés</Button>
                <Button color="primary" type="button" onClick={(e) => window.history.back()}><FontAwesomeIcon icon={faArrowLeft} /> Mégsem</Button>
            </Form>
        );

    return null;
}

export default UserEditForm;
